import React, { useState } from 'react';
import { Space, Select, Button, Tooltip, Modal, DatePicker, Typography } from 'antd';
import { UploadOutlined, DownloadOutlined, ThunderboltOutlined, CheckCircleOutlined, FileExcelOutlined, CalendarOutlined } from '@ant-design/icons';
import moment from 'moment';
import BuscarPorOrdenPagoID from '../CrearOrdenPago/BuscarPorOrdenPagoID';
import BuscarPorAsistenciaID from '../CrearOrdenPago/BuscarPorAsistenciaID';

const { Option } = Select;
const { Text, Title } = Typography;

export default function FiltrosPagosV2({
  estatusSeleccionado,
  setEstatusSeleccionado,
  estatusOptions,
  onCargaMasivaPDF,
  onCargaMasivaXLSX,
  onDescargarXLS,
  onDescargarXlsComplementosPago,
  onAutorizarMasivo
}) {
  const [modalAnioVisible, setModalAnioVisible] = useState(false);
  const [anio, setAnio] = useState(moment());
  const [loadingXlsComplementos, setLoadingXlsComplementos] = useState(false);

  const descargarXlsComplementos = async () => {
    if (!anio) return;

    setLoadingXlsComplementos(true);

    try {
      await onDescargarXlsComplementosPago(anio.format('YYYY'));
    } finally {
      setLoadingXlsComplementos(false);
    }
  };

  return (
    <>
      <Space size="middle">
        <Select
          placeholder="Selecciona un estatus"
          style={{ width: 350 }}
          value={estatusSeleccionado}
          onChange={setEstatusSeleccionado}
        >
          {estatusOptions.map(option => (
            <Option key={option.value} value={option.value}>
              {option.label}
            </Option>
          ))}
        </Select>

        <BuscarPorOrdenPagoID />
        <BuscarPorAsistenciaID />

        <Tooltip title="Descargar XLS de órdenes de pago activas">
          <Button
            type="default"
            icon={<DownloadOutlined />}
            onClick={onDescargarXLS}
          >
          </Button>
        </Tooltip>

        {(estatusSeleccionado === 2 || estatusSeleccionado === 3) && (
          <Tooltip title="Autorizar Masivo">
            <Button
              type="primary"
              ghost
              icon={<ThunderboltOutlined />}
              onClick={onAutorizarMasivo}
            >
            </Button>
          </Tooltip>
        )}

        {estatusSeleccionado === 7 && (
          <>
            <Tooltip title="Carga masiva de comprobantes de pago PDF">
              <Button
                type="default"
                icon={<UploadOutlined />}
                onClick={onCargaMasivaPDF}
              >
                Carga Masiva PDF
              </Button>
            </Tooltip>
            <Tooltip title="Marcar como pagado múltiples órdenes">
              <Button
                type="default"
                icon={<CheckCircleOutlined />}
                onClick={onCargaMasivaXLSX}
              >
                Marcar Pagado Masivo
              </Button>
            </Tooltip>
          </>
        )}

        {estatusSeleccionado === 9 && (
          <Button
            type="default"
            className="xls-complementos-button"
            icon={<FileExcelOutlined />}
            onClick={() => {
              setAnio(moment());
              setModalAnioVisible(true);
            }}
          >
            XLS Complementos de pago
          </Button>
        )}
      </Space>

      <Modal
        title={<><CalendarOutlined className="xls-complementos-modal__title-icon" />Generar XLS</>}
        open={modalAnioVisible}
        wrapClassName="pagos-v2-modal xls-complementos-modal"
        onOk={descargarXlsComplementos}
        onCancel={() => setModalAnioVisible(false)}
        confirmLoading={loadingXlsComplementos}
        okButtonProps={{ disabled: !anio }}
        okText="OK"
        cancelText="Cancelar"
      >
        <div className="xls-complementos-modal__intro">
          <Title level={3} className="xls-complementos-modal__heading">
            Complementos de pago
          </Title>
          <Text type="secondary" className="xls-complementos-modal__description">
            Selecciona el año para descargar las órdenes con complemento de pago.
          </Text>
        </div>
        <DatePicker
          className="xls-complementos-modal__picker"
          value={anio}
          picker="year"
          style={{ width: '100%' }}
          onChange={setAnio}
        />
      </Modal>
    </>
  );
}
